export default __webpack_public_path__ + "static/backtap-7aa7b37e7511c768d418a737085534e4.mp4";